module.exports = "/assets/thumbs-down-9aaa6f7979ff69c7b9be85fe7a659b64.svg";